import { Component, OnInit, Input } from '@angular/core';
import { VisitorService, VisitorResponse } from '../../../services/visitor.service';
import { Visitor } from '../../../models/visitor';

export enum NumberCardType {
  Total,
  Average
}

@Component({
  selector: 'number-card',
  templateUrl: './number-card.component.html',
  styleUrls: ['./number-card.component.css']
})
export class NumberCardComponent implements OnInit {

  private numberCardType: NumberCardType;

  value: number;
  name: string;
  minDate: string;
  maxDate: string;

  @Input()
  numberCardTypeString: string;

  constructor(private _visitorService: VisitorService) {
    // Create subscription
    _visitorService.getVisitorSubject().subscribe((visitorResponses: VisitorResponse[]) => {
      this.updateValueFromVisitorResponses(visitorResponses);
    })
  }

  updateValue(visitors: Visitor[]) {
    if(visitors.length <= 0) {
      return;
    }

    this.minDate = visitors[0].name;
    this.maxDate = visitors[visitors.length-1].name;

    setTimeout( () => { this.value = 0; }, 300 );
    let count: number = 0;
    let totalValue: number = 0;

    visitors.forEach(visitor => {

      switch(this.numberCardType) {
        case NumberCardType.Average:
          // Set Timeout adds a kind of 'animation' by delaying the update
          setTimeout( () => { 
            totalValue += visitor.value;
            this.value = Math.round(totalValue / count);
          }, 300 + (count * 10) );
          break;

        case NumberCardType.Total:
          // Set Timeout adds a kind of 'animation' by delaying the update
          setTimeout( () => { 
            this.value += visitor.value; 
          }, 300 + (count * 10) );
          break;
      }

      count++;
    });
  }

  updateValueFromVisitorResponses(visitorResponses: VisitorResponse[]) {
    // Number card only represents one value,
    // so we take the first (0th) value
    // In theory, number card should never be sent more than one value anyway
    if(visitorResponses.length > 0) {
      this.updateValue(visitorResponses[0].values);
    }
    else {
      this.updateValue([]);
    }
  }

  ngOnInit() {
    this.numberCardType = NumberCardType[this.numberCardTypeString];
    if(this.numberCardType == undefined) {
      console.log("Invalid NumberCardType. Set numberCardTypeString to \"Total\" or \"Average\" in html");
    }

    switch(this.numberCardType) {
      case NumberCardType.Average:
        this.name = "Average Visitor Count";
        break;
      case NumberCardType.Total:
        this.name = "Total Visitor Count";
        break;
    }

    // Update with current value from visitor service
    let visitorResponses: VisitorResponse[] = this._visitorService.getVisitorSubject().value;
    this.updateValueFromVisitorResponses(visitorResponses)
  }
}
